module.exports = __webpack_public_path__ + "img/ricelog_pinicon_042.e0f64555.png";